import Header from '../Components/Header';
import Footer from '../Components/Footer';


function Privacy() {
  return (
    <div >

      <Header />
    

      <div className='container main-contant terms-content'>
        <div className='inner-page-container'>
          <h1 className='page-title'>Privacy Policy</h1>
          <div className='row'>


            <div className='col-md-12'>

              <p>
    At <strong>Aadikaash International</strong>, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you visit our website <a href="https://aadikaash.com" target="_blank">https://aadikaash.com</a> or participate in any of our events.
  </p>
  <p>
    By using our website or submitting your information, you agree to the terms outlined in this policy.
  </p>

  <h2>1. Information We Collect</h2>
  <h3>a) Personal Information</h3>
  <ul>
    <li>Name</li>
    <li>Company name</li>
    <li>Email address</li>
    <li>Phone number</li>
    <li>Address</li>
    <li>GST or business registration details</li>
  </ul>

  <h3>b) Technical Information</h3>
  <ul>
    <li>IP address</li>
    <li>Browser type and version</li>
    <li>Operating system</li>
    <li>Referring URLs</li>
    <li>Pages visited and time spent</li>
  </ul>

  <h3>c) Event-Related Information</h3>
  <ul>
    <li>Registration details</li>
    <li>Booth preferences</li>
    <li>Payment or billing info (via third-party)</li>
  </ul>

  <h2>2. How We Use Your Information</h2>
  <ul>
    <li>Process event registrations and exhibitor bookings</li>
    <li>Send updates, confirmations, or promotional emails</li>
    <li>Improve our website and services</li>
    <li>Fulfill legal obligations</li>
  </ul>

  <h2>3. Cookies</h2>
  <p>
    Our website uses cookies to improve your browsing experience. Cookies help us recognize returning users, monitor performance, and personalize content. You can manage cookies through your browser settings.
  </p>

  <h2>4. Sharing of Information</h2>
  <p>
    We do <strong>not</strong> sell or rent your personal data. We may share it with:
  </p>
  <ul>
    <li>Trusted third-party vendors (e.g., payment gateways)</li>
    <li>Government authorities (if legally required)</li>
    <li>Marketing partners (with your consent)</li>
  </ul>

  <h2>5. Data Security</h2>
  <p>
    We use secure technologies like SSL encryption, limited access, and secure servers to protect your data. However, no online method is 100% secure.
  </p>

  <h2>6. Your Rights</h2>
  <p>You have the right to:</p>
  <ul>
    <li>Access, update, or delete your personal information.</li>
    <li>Opt-out of receiving marketing communications.</li>
    <li>Request a copy of the information we hold about you.</li>
  </ul>
  <p>
    To exercise your rights, email us at <a href="mailto:info@aadikaash.com">info@aadikaash.com</a>.
  </p>

  <h2>7. Retention Policy</h2>
  <p>
    We retain personal information only as long as necessary for the purposes it was collected, or as required by law.
  </p>

  <h2>8. Third-Party Links</h2>
  <p>
    Our website may include links to other websites. We are not responsible for their privacy policies or practices.
  </p>

  <h2>9. Changes to This Policy</h2>
  <p>
    We may update this Privacy Policy periodically. Continued use of the site after changes are posted implies your acceptance.
  </p>

  <h2>Consent</h2>
<p>By using our website, you hereby consent to our <a href="https://aadikaash.com/privacy-policy" target="_blank">Privacy Policy</a> and agree to its terms. If you do not agree with any part of this policy, please refrain from using our website and services.</p>


              

            </div>


          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Privacy;
